import {
  FormattedMessage,
  injectIntl,
  type intlFormatPropTypes,
} from "react-intl";

import { Divider } from "@ps-design-system/components/Divider";
import { Text } from "@ps-design-system/components/Text";

import { AddressFields, FieldLabelWithTooltip } from "../../../AddressForm";
import { TAX_DETAILS_ADDRESS_FIELDS } from "../TaxDetailsFormSection.consts";
import { TAX_DETAILS_FORM_MESSAGES } from "../TaxDetailsFormSection.messages";

import { useTaxDetailsForm } from "./TaxDetailsFormContext";

type TaxDetailsFormAddressProps = { intl: intlFormatPropTypes };

/**
 * The address the registration is held under, which is not necessarily the one on
 * the account — hence the tooltip on the street field.
 */
const TaxDetailsFormAddressComponent = ({
  intl,
}: TaxDetailsFormAddressProps) => {
  const {
    countryOptions,
    isCountryLocked,
    selectedCountry,
    taxTypeName,
    zoneOptions,
  } = useTaxDetailsForm();

  return (
    <div className="tw-flex tw-flex-col tw-gap-24">
      <Divider className="tw-m-0" />

      <Text element="h2" typeface="headline-2-m">
        <FormattedMessage
          {...TAX_DETAILS_FORM_MESSAGES.addressHeading}
          values={{ taxType: taxTypeName }}
        />
      </Text>

      <AddressFields
        countryDisabled={isCountryLocked}
        countryLabels={selectedCountry?.labels}
        countryOptions={countryOptions}
        names={TAX_DETAILS_ADDRESS_FIELDS}
        renderStreetLabel={(label) => (
          <FieldLabelWithTooltip
            body={
              <FormattedMessage
                {...TAX_DETAILS_FORM_MESSAGES.addressTooltipBody}
                values={{ taxType: taxTypeName }}
              />
            }
            heading={
              <FormattedMessage
                {...TAX_DETAILS_FORM_MESSAGES.addressTooltipTrigger}
                values={{ taxType: taxTypeName }}
              />
            }
            label={label}
            triggerLabel={intl.formatMessage(
              TAX_DETAILS_FORM_MESSAGES.addressTooltipTrigger,
              { taxType: taxTypeName },
            )}
          />
        )}
        testIdPrefix="tax-details"
        zoneOptions={zoneOptions}
      />
    </div>
  );
};

const TaxDetailsFormAddress = injectIntl(TaxDetailsFormAddressComponent);

export { TaxDetailsFormAddress };
